import { render } from "./RegraList.vue?vue&type=template&id=650aa8d2"
import script from "./RegraList.vue?vue&type=script&lang=js"
export * from "./RegraList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__